// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2Jpr5","header":"PatientBlock_header__30nPb","label":"PatientBlock_label__1Jw51","option":"PatientBlock_option__29QIN"};